var moment = require('moment'); // require

export default function HeatByHeatResults(){
  const eventUrl = window.location.pathname.split('/')
  const eventSanction = eventUrl[2]
  const containerHeader = $('#event-header')
  const containerDate = $('#event-date span')
  const containerFiles = $('#event-files')
  const containerResults = $('#event-results')
  
  if( ! containerHeader.length ) { return; }

  const loaded = (target) => $(target).addClass('loaded')
  const error = () => console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
  const Render = {
    date: function(date) {
      containerDate.html(date)
    },
    header: function(venue,name,location) {
      let headerContent = ''
      headerContent += `<h2 class="underlined">EVENT RESULTS</h2>`
      headerContent += `<div class="hbh-results-details-title">${name}</div>`
      headerContent += `<div class="hbh-results-details-venue">${venue}</div>`
      headerContent += `<div class="hbh-results-details-location">${location}</div>`
      containerHeader.html(headerContent)
    },   
    entryLists: function(eventClases) {
      let filesContent = ''
      for(let eventClass of eventClases){
          const fileTitle = eventClass.CSN
          const fileUrl = eventClass.L
        filesContent += `<a href="http://americanmotocrossresults.com${fileUrl}" target="_blank" class="btn btn-purple btn-small">${fileTitle} Entry List</a>`
      }
      containerFiles.html(filesContent)
    },
    classes: function(eventClases){
      let resultsContent = ''
      for(let eventClass of eventClases){
        const name = eventClass.CSN
        const slug = name.replace(/\s+/g, '-').toLowerCase();
        // const name = eventClass.CSN.substring(0, eventClass.CSN.length - 2)
        resultsContent += `<div id="" class="hbh-results-results-col">`
        resultsContent += `  <div class="hbh-results-results-heading">${name}</div>`
        resultsContent += `  <div id="events-wrapper-${slug}" class="wrapper"></div>`
        resultsContent += `  <div class="wrapper bottom the-class-results">`
        resultsContent += `    <div class="hbh-results-results-block">`
        resultsContent += `       <div class="hbh-results-results-block-options">`
        resultsContent += `         <a href="overall/${eventClass.C}/${name}" class="btn btn-green btn-small">Official Results</a>`
       if(name === '450SMX' || name === '250SMX'){
         resultsContent += `         <a href="rider-points/${eventClass.C}/${name}" class="btn btn-green btn-small">Rider Points Standings</a>`
         resultsContent += `         <a href="rider-points-pos/${eventClass.C}/${name}" class="btn btn-green btn-small">Rider Points Standings (POS)</a>`		
       }
        resultsContent += `       </div>`
        resultsContent += `    </div>`
        resultsContent += `  </div>`
        resultsContent += `</div>`
      }
      containerResults.html(resultsContent)
      $.ajax( {
        url: `https://data-aws.amaproracing.com/api/event/schedule/${eventSanction}`,
        method: 'GET',
        dataType: 'json',
        error: () => error(),
        success: data => {
          const dataFiltered = data.filter((event) => event.Type !== 'Z');
          // console.log(data)
          // console.log(dataFiltered)
          Render.results(dataFiltered)
        }
      });
    },
    results: function(source){
      // SMX
      const results250 = source.filter((result) => result.Class === 'X2')
      const results450 = source.filter((result) => result.Class === 'X1')
      const resultsAllStars = source.filter((result) => result.Class === 'X6')
      const resultsMini = source.filter((result) => result.Class === 'XM')
      const resultsFutures = source.filter((result) => result.Class === 'XF')
      const containerResults250 = $('#events-wrapper-250smx')
      const containerResults450 = $('#events-wrapper-450smx')
      const containerResultsAllStars = $('#events-wrapper-all-stars')
      const containerResultsMini = $('#events-wrapper-supermini')
      const containerResultsFutures = $('#events-wrapper-futures')
      Render.result(results250,containerResults250)
      Render.result(results450,containerResults450)
      Render.result(resultsAllStars,containerResultsAllStars)
      Render.result(resultsMini,containerResultsMini)
      Render.result(resultsFutures,containerResultsFutures)

      // MX
      // const results250 = source.filter((result) => result.Class === 'M2')
      // const results450 = source.filter((result) => result.Class === 'M1')
      // const resultsAllStars = source.filter((result) => result.Class === 'SC')
      // const containerResults250 = $('#events-wrapper-250mx')
      // const containerResults450 = $('#events-wrapper-450mx')
      // const containerResultsAllStars = $('#events-wrapper-scouting-moto-combine')
      // Render.result(results250,containerResults250)
      // Render.result(results450,containerResults450)
      // Render.result(resultsAllStars,containerResultsAllStars)

      // SX
      // const results250 = source.filter((result) => result.Class === 'S2')
      // const results450 = source.filter((result) => result.Class === 'S1')
      // const containerResults250 = $('#events-wrapper-250sx')
      // const containerResults450 = $('#events-wrapper-450sx')
      // Render.result(results250,containerResults250)
      // Render.result(results450,containerResults450)
    },
    result: function(source, container) {
      let resultsContent = ``
      for (let event of source){
        const eventName = event.SessionName
        const eventNameSlug = eventName.replace(/\s+/g, '-').toLowerCase()
        const eventTime = event.SchedStart
        const eventHour = moment( eventTime ).format( 'MM/DD/YYYY h:mm a' )
        const eventId = event.PkSessionInfoID
        $.ajax( {
          url: `https://data-aws.amaproracing.com/api/lineup/${eventId}`,
          method: 'GET',
          dataType: 'json',
          error: () => error(),
          success: data => {
            if (data.length < 1){
              $(`#session-${eventId}`).addClass('no-lineup')
            }
          }
        });

        $.ajax( {
          url: `https://data-aws.amaproracing.com/api/reporting/combinedtimes/${eventId}`,
          method: 'GET',
          dataType: 'json',
          error: () => error(),
          success: data => {
            if (! data[0].CombinedLapTimes){
              $(`#session-${eventId}`).addClass('no-qualy')
            }
            if (eventName.includes("Qualifying 2")){
              $(`#session-${eventId}`).addClass('has-qualy')
            }
          }
        });
        

        resultsContent += `<div class="hbh-results-results-block" id="session-${eventId}">`
        resultsContent += `<div class="hbh-results-results-block-title">${eventName}</div>`
        resultsContent += `<div class="hbh-results-results-block-time">${eventHour}</div>`
        resultsContent += `<div class="hbh-results-results-block-options">`
        
        if( event.Complete === true ) {
          resultsContent += `  <a href="starting-line-up/${eventId}/${eventNameSlug}" class="btn btn-purple btn-small sessionlineup">Starting Line Up</a>`
          resultsContent += `  <a href="best-lap/${eventId}/${eventNameSlug}" class="btn btn-purple btn-small">Best Lap Times</a>`
          resultsContent += `  <a href="individual-lap/${eventId}/${eventNameSlug}" class="btn btn-purple btn-small">Individual Lap Times</a>`
          resultsContent += `  <a href="individual-segment/${eventId}/${eventNameSlug}" class="btn btn-purple btn-small">Individual Segment Times</a>`
          resultsContent += `  <a href="best-segment/${eventId}/${eventNameSlug}" class="btn btn-purple btn-small">Best Segment Times</a>`
          resultsContent += `  <a href="combined-qualifying/${eventId}" class="btn btn-green btn-small qualy">Combined Qualifying Times</a>`
          // resultsContent += `  <a href="rider-points/${eventId}/${eventNameSlug}" class="btn btn-purple btn-small">Rider Points Standings</a>`
          //resultsContent += `  <a href="rider-points-pos/${eventId}/${eventNameSlug}" class="btn btn-purple btn-small">Rider Points Standings POS</a>`					
        } else {			
          resultsContent += `  <span class="btn btn-gray btn-small">Results Not Available</span>`
          $('.the-class-results').addClass('hideThis')
        }
		
        resultsContent += `</div>`
        resultsContent += `</div>`
      }
      container.html(resultsContent)
    }
  }

  $.ajax( {
    url: `https://data-aws.amaproracing.com/api/apps/event/SX/${eventSanction}`,
    method: 'GET',
    dataType: 'json',
    error: () => error(),
    success: data => {
      const results = data[0].B[0]
      const clases = results.CLASSES
      const name = results.E
      const venue = results.T
      const location = results.L
      const date = results.D

      // setTitle(name)
      Render.header(venue,name,location)
      Render.date(date)
      Render.entryLists(clases)
      Render.classes(clases)
      loaded('#hbh-results')
    }
  });

}